import { useState, useEffect } from 'react';
import { Tooltip, makeStyles, IconButton } from '@material-ui/core';
import { LockOutlined, ReplayOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: { display: 'flex' },
  assetEditorWrapper: { width: '100%' },
  iconButtonWrapper: { height: 36, marginTop: 10, marginLeft: 16 },
  iconButton: {
    color: theme.palette.primary.text6,
    width: 36,
    height: 36,
    '&:hover': { backgroundColor: theme.palette.background.b7 },
  },
}));

const withAssetEditorLockHOC = WrappedComponent => props => {
  const styles = useStyles();
  const { onChangeEditorField, onSettingsChange } = props;
  const [locked, setLocked] = useState(true);
  const [showAssetEditor, setShowAssetEditor] = useState(true);

  const resetPlatformApp = () => {
    onChangeEditorField('assetId', null);
    onChangeEditorField('replacedAssetId', null);
    onChangeEditorField('replacedAssetTime', null);
  };
  const resetDCApp = () => {
    onSettingsChange({ rigId: null, wellId: null });
  };

  const onToggleAssetEditorLock = () => {
    const nextValue = !locked;
    setLocked(nextValue);
    if (nextValue) {
      const resetApp = onChangeEditorField ? resetPlatformApp : resetDCApp;
      resetApp();
      setShowAssetEditor(false);
    }
  };

  useEffect(() => {
    // NOTE: Here we force AssetEditor remount to correctly reset its state
    if (!showAssetEditor) {
      setShowAssetEditor(true);
    }
  }, [showAssetEditor]);

  const Icon = locked ? LockOutlined : ReplayOutlined;
  return (
    <div className={styles.root}>
      <Tooltip
        title={locked ? 'This app is using current dashboard asset.' : ''}
        placement="bottom"
      >
        <div className={styles.assetEditorWrapper}>
          {showAssetEditor && <WrappedComponent {...props} disabled={locked} />}
        </div>
      </Tooltip>
      <Tooltip title={locked ? 'Unlock Asset' : 'Return default'} placement="bottom">
        <div className={styles.iconButtonWrapper}>
          <IconButton
            className={styles.iconButton}
            data-testid={`${locked ? 'UnlockAsset' : 'ReturnDefault'}_IconButton`}
            onClick={onToggleAssetEditorLock}
          >
            <Icon />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
};

export default withAssetEditorLockHOC;
